export default __webpack_public_path__ + "static/media/error-img.352b9ab6.png";